import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import { LayoutContent } from "../Components/Shared/Layout/LayoutContent";
import Image from "../Components/Shared/Layout/Image";
import Banner from "../Components/Shared/Layout/Banner";
import withLanguage from "../HOC/withLanguage";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ImageText from "../Components/HomePage/ImageText";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { schoolFilterChange } from "../redux/reducers/schoolFiltersSlice";
import { useDispatch } from "react-redux";
import InfoBalls from "../Components/HomePage/InfoBalls";
import Contact from "../Components/HomePage/Contact";
import { setUser } from "../redux/reducers/userSlice";

const HomePage = ({ language }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const infoBallsConfig = [
        { path: "/si-te-aplikosh", name: language?.inputBanner?.infoBall1, hideMobile: false, src: "/icon1.svg" },
        { path: "https://e-albania.al/eAlbaniaServices/UseService.aspx?service_code=12549", name: language?.inputBanner?.infoBall2, hideMobile: false, src: "/icon2.svg" },
    ];

    // Handle token from e-Albania redirect
    useEffect(() => {
        const sp = new URLSearchParams(location.search);
        const access = sp.get("access_token");
        const id = sp.get("id_token");
        const type = sp.get("token_type");
        const expires = sp.get("expires");

        if (access) {
            localStorage.setItem("access_token", access);
            if (id) localStorage.setItem("id_token", id);
            if (type) localStorage.setItem("token_type", type);
            if (expires) localStorage.setItem("expires", expires);

            fetch('/api/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'text/plain' },
                body: JSON.stringify({ access_token: access }),
            })
                .then(res => res.json())
                .then(userData => {
                    dispatch(setUser(userData));
                    console.log("User data received:", userData);
                })
                .catch(err => console.error("Backend login failed:", err));

            navigate("/", { replace: true });
        }
    }, [location.search, navigate, dispatch]);

    return (
        <>
            <Banner img='/mainBanner.png' title={isMobile ? language.banner2 : language.banner} block={isMobile ? language.bannerBlock : ""} input={true} infoBallsConfig={infoBallsConfig} containerClass="h-[40vh]" />

            <LayoutContent mobileFullWidth={true} grid={false}>
                <div className="text-center text-3xl max-md:text-xl py-2 bg-[#DB3222] text-white">
                    {language.mainTitle1}
                </div>
                <div className="flex flex-col md:text-xl text-lg gap-3 max-md:mx-4">
                    <div className="grid md:grid-cols-2 grid-cols-1 gap-12">
                        <Link className="cursor-pointer " to="/arsimi-i-mesem"><Image src="/home-images/Picture1.png"/></Link>
                        <div className="flex flex-col ">
                            <Link className="text-red-600 cursor-pointer mt-12 block" to="/arsimi-i-mesem">{language.ap1}</Link>
                            <p className="md:text-xl text-lg mb-12">{language.ap2}</p>
                        </div>
                    </div>
                    <div className="grid md:grid-cols-2 grid-cols-1 gap-12">
                        <div className="flex flex-col max-md:order-last">
                            <Link className="text-red-600 cursor-pointer mt-12 block" to="/nxenesi-arsimi-dual">{language.dual1}</Link>
                            <p className="mb-12">{language.dual2}</p>
                        </div>
                        <Link className="cursor-pointer" to="/nxenesi-arsimi-dual"><Image src="/ArsimiIMesem/banner.jpg"/></Link>
                    </div>
                    <div className="grid md:grid-cols-2 grid-cols-1 gap-12">
                        <button className="cursor-pointer" onClick={() => {
                            dispatch(schoolFilterChange("qendra"))
                            navigate("/shkollat")
                        }}><Image src="/home-images/Picture3.jpg"/></button>
                        <div className="flex flex-col">
                            <p onClick={() => {
                                dispatch(schoolFilterChange("qendra"))
                                navigate("/shkollat")
                            }} className="text-red-600 cursor-pointer mt-12 block">{language.fp1}</p>
                            <p className="md:text-xl text-lg mb-12">{language.fp2}</p>
                        </div>
                    </div>
                </div>
                {/*<ImageText className="flex-row-reverse" href="/arsimi-i-mesem" imageStyle={{objectPosition:"60% 75%"}} title={language.afpSistem} format="2" description={language.afpSistemDescription} src="/ArsimiIMesem/banner.jpg"/>*/}
                {/*<div className="md:grid md:grid-cols-2 gap-6">*/}
                {/*    <ImageText href="/Drejtime" title={language.directionOfStudies} format="1" description={language.directionOfStudiesDescription} src="/fileIcon.svg"/>*/}
                {/*    <ImageText href="/shkollat" title={language.aboutInstitution} format="1" description={language.aboutInstitutionDescription} src="/manCheckIcon.svg"/>*/}
                {/*</div>*/}
                <div className="grid md:grid-cols-2 grid-cols-1 gap-12 mt-12 text-white mx-4">
                    <div className="flex items-center flex-col gap-5 ">
                        <Image src="/fileIcon.svg" className="max-w-[150px]"/>
                        <h6 className="text-3xl font-bold text-red-600">{language.logoTitle1}</h6>
                        <div className="flex items-center justify-center gap-5 w-full max-md:flex-col">
                            <button className="p-3 min-h-20 bg-[#DB3222] rounded-lg w-full" onClick={() => {
                                navigate('/arsimi-i-mesem')
                            }}>{language.arsimiProfesional}</button>
                            <button className="p-3 min-h-20 bg-[#DB3222] rounded-lg w-full" onClick={() => {
                                navigate('/nxenesi-arsimi-dual')
                            }}>{language.arsimiProfesionalDual}</button>
                            <button className="p-3 min-h-20 bg-[#DB3222] rounded-lg w-full" onClick={() => {
                                navigate('/sistemi-profesional')
                            }}>{language.formimiProfesional}</button>
                        </div>
                    </div>
                    <div className="flex items-center flex-col gap-5 mx-4">
                        <Image src="/manCheckIcon.svg" className="max-w-[150px]"/>
                        <h6 className="text-3xl font-bold text-red-600">{language.logoTitle1}</h6>
                        <div className="flex items-center justify-center gap-5 w-full max-md:flex-col">
                            <button className="p-3 min-h-20 bg-[#DB3222] rounded-lg w-full" onClick={() => {
                                dispatch(schoolFilterChange("shkolla"))
                                navigate("/shkollat")
                            }}>{language.shkollaProfesionale}</button>
                            <button className="p-3 min-h-20 bg-[#DB3222] rounded-lg w-full" onClick={() => {
                                navigate('/intitucioni-arsimor')
                            }}>{language.shkollaProfesionaleDual}</button>
                            <button className="p-3 min-h-20 bg-[#DB3222] rounded-lg w-full" onClick={() => {
                                dispatch(schoolFilterChange("qendra"))
                                navigate("/shkollat")
                            }}>{language.qenderFormimiProfesional}</button>
                        </div>
                    </div>
                </div>

                <ImageText href="/si-te-aplikosh" title={language.howToApply} format="3"  src="/laptopE-albaniaIcon.svg"/>
                <div style={{ backgroundColor: "white" }} className="flex gap-4 justify-around w-full pt-2 px-4 md:px-20 lg:px-52">
                    {infoBallsConfig.map(infoItem => (
                        <InfoBalls {...infoItem} />
                    ))}
                </div>
                <ImageText href="https://www.puna.gov.al/" imageStyle={{objectPosition:"25% 75%"}} title={language.internship} format="2" description={language.internshipDetails} src="/block4element.jpg"/>
                <div className="md:grid md:grid-cols-2 gap-6">
                    <ImageText href="/learning-practice" title={language.practicalLearning} format="4" src="/image30996.png"/>
                    <ImageText href="/bursa-transport"  title={language.transportGrants} format="4" src="/g31010.png"/>
                </div>
                <a className='block relative' href="https://afpro.al/">
                    <Box className="bg-black absolute h-full w-full opacity-40"></Box>
                    <Image src="image27824.png" />
                    <Box className="absolute font-bold text-bold flex flex-col text-white top-[50%] left-1/2 transform -translate-x-1/2 -translate-y-[50%] w-[80%] xs:w-auto">
                        <h1 className='text-center md:text-5xl text-3xl uppercase text-[white] font-bold'>
                            {language.buttonElTitle}
                        </h1>
                        <h3 className='text-center md:text-3xl text-md py-3 md:py-5'>
                            {language.buttonElText}
                        </h3>
                    </Box>
                </a>
                <Contact />
                {/*<p className="text-3xl md:text-5xl font-bold text-center">{language.socialMedia}</p>*/}
                {/*<div className='flex flex-row justify-center gap-8 pb-8'>*/}
                {/*    {socialMediaConfig.map(({ platform, url, icon }) => (*/}
                {/*        <a key={platform} href={url} target="_blank" className="flex justify-center items-center p-1 sm:mx-3 md:mx-10">*/}
                {/*            <img src={icon} className='max-w-[30px] max-h-[30px] md:max-w-[50px] md:max-h-[50px]' alt={`${platform} Icon`} />*/}
                {/*        </a>*/}
                {/*    ))}*/}
                {/*</div>*/}
            </LayoutContent>
        </>
    )
}
export default withLanguage(HomePage,"Homepage")